import { RenewMessage2 } from '../strings.locstring.json';
import {
    UpgradeMessage1,
    UpgradeMessage2,
    ReactiveMessage,
    UpsellControlMessage,
    UpsellServiceMessage1,
    UpsellServiceMessage2,
    UpsellServiceMessage3,
    mailboxSecurityMessage,
    GetMobileApplicationMessage,
} from './LeftnavUpsellState.locstring.json';
import loc from 'owa-localize';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import { LeftNavUpsellState, ButtonIconType } from '../store/schema/leftNavUpsellState';
import { getExperienceTypeForUser, PremiumExperienceType } from 'owa-premium-travel';

export async function getUpsellState(): Promise<LeftNavUpsellState> {
    const userExperienceType = await getExperienceTypeForUser();
    if (userExperienceType == PremiumExperienceType.NonPremiumTravelUpsell) {
        return upsellState.regularTravelUpsell;
    } else if (userExperienceType == PremiumExperienceType.NonPremiumDomainConnectUpsell) {
        return upsellState.regularDomainUpsell;
    } else if (isFeatureEnabled('sig-LeftNavOfficeButtonsTreatment1')) {
        return upsellState.officeAppsNoUpsell;
    } else if (isFeatureEnabled('sig-LeftNavOfficeButtonsTreatment2')) {
        return upsellState.upsellWithOfficeApps;
    } else if (isFeatureEnabled('sig-LeftNavOfficeButtonsControl')) {
        return upsellState.upsellWithoutOfficeAppsControl;
    } else if (isFeatureEnabled('auth-LeftNavUpsellAdvancedSecurity')) {
        return upsellState.upsellMailboxSecurityPremiumFeature;
    } else if (isFeatureEnabled('auth-LeftNavUpsellFreeServicesTreatment')) {
        return upsellState.upsellFreeServiceStorage;
    } else if (isFeatureEnabled('auth-LeftNavUpsellFreeServicesControl')) {
        return upsellState.upsellFreeServiceControl;
    } else if (isFeatureEnabled('auth-LeftNavUpsellGetMobile')) {
        return upsellState.upsellGetMobileApp;
    } else {
        return upsellState.regularUpsell;
    }
}

/// Get the next upsell state for the LeftNavUpsellFreeServicesTreatment flag
export function getNextUpsellStateForRotatingStates(state: LeftNavUpsellState): LeftNavUpsellState {
    // The states in which we want to rotate
    const rotatingStates: LeftNavUpsellState[] = [
        upsellState.upsellFreeServiceStorage,
        upsellState.upsellFreeServiceOffice,
        upsellState.upsellFreeServicePremiumFeatures,
    ];
    // Find the index of the current state
    let index = findIndex(rotatingStates, rotatingState => rotatingState.url == state.url);
    // If the current state is not in the   we should return the current state (its a renew scenario and we dont want to modify in that scenario)
    if (index == -1) {
        return state;
    }
    // Get the next stateIndex and return that state
    let nextState = index + 1 >= rotatingStates.length ? 0 : index + 1;
    return rotatingStates[nextState];
}

function findIndex<T>(array: T[], predicate: (item: T) => boolean): number {
    for (let i = 0; i < array.length; i++) {
        if (predicate(array[i])) {
            return i;
        }
    }
    return -1;
}

const diamondIconPath = 'resources/leftNavUpsellIcons/premium-diamond-01.svg';
const documentIconPath = 'resources/leftNavUpsellIcons/officeapps.svg';
const balloonIconPath = 'resources/leftNavUpsellIcons/onedriveballoons.svg';

const upsellState = {
    regularUpsell: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=867712&WT.mc_id=PROD_OL-Web_InApp_LeftNav_Upgrade&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellDisplayed',
        datapointNameClicked: 'LeftNavPremiumUpsellClicked',
        buttonText: loc(UpgradeMessage1),
        buttonTextLine2: loc(UpgradeMessage2),
        buttonIconPath: diamondIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
    regularTravelUpsell: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=2005900&WT.mc_id=PROD_OL-Web_InApp_LeftNav_TravelUpgrade&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellDisplayed',
        datapointNameClicked: 'LeftNavPremiumUpsellClicked',
        buttonText: loc(UpgradeMessage1),
        buttonTextLine2: loc(UpgradeMessage2),
        buttonIconPath: diamondIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
    regularDomainUpsell: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=2005900&WT.mc_id=PROD_OL-Web_InApp_LeftNav_DomainUpgrade&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellDisplayed',
        datapointNameClicked: 'LeftNavPremiumUpsellClicked',
        buttonText: loc(UpgradeMessage1),
        buttonTextLine2: loc(UpgradeMessage2),
        buttonIconPath: diamondIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
    noCCTreatmentRenewUpsell: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=867712&WT.mc_id=PROD_OL-Web_InApp_LeftNav_NoCCTreatmentRenew&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellRenewNoCCTreatment',
        datapointNameClicked: 'LeftNavPremiumUpsellRenewClickedNoCCTreatment',
        buttonText: loc(RenewMessage2),
        buttonTextLine2: '',
        buttonIconPath: diamondIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
    noCCTreatmentReactivateUpsell: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=867712&WT.mc_id=PROD_OL-Web_InApp_LeftNav_NoCCTreatmentReactivate&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellReactivateDisplayedNoCCTreatment',
        datapointNameClicked: 'LeftNavPremiumUpsellReactivateClickedNoCCTreatment',
        buttonText: loc(ReactiveMessage),
        buttonTextLine2: loc(UpgradeMessage2),
        buttonIconPath: diamondIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
    upsellFreeServiceControl: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=867712&WT.mc_id=PROD_OL-Web_InApp_LeftNav_FreeServicesControlUpgrade&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellDisplayedFreeServiceControl',
        datapointNameClicked: 'LeftNavPremiumUpsellClickedFreeServiceControl',
        buttonText: loc(UpsellControlMessage),
        buttonTextLine2: '',
        buttonIconPath: diamondIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
    upsellFreeServiceStorage: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=867712&WT.mc_id=PROD_OL-Web_InApp_LeftNav_FreeServicesTreatmentOD&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellDisplayedFreeServiceStorage',
        datapointNameClicked: 'LeftNavPremiumUpsellClickedFreeServiceStorage',
        buttonText: loc(UpsellServiceMessage1),
        buttonTextLine2: '',
        buttonIconPath: balloonIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
    upsellFreeServiceOffice: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=867712&WT.mc_id=PROD_OL-Web_InApp_LeftNav_FreeServicesTreatmentWXP&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellDisplayedFreeServiceOffice',
        datapointNameClicked: 'LeftNavPremiumUpsellClickedFreeServiceOffice',
        buttonText: loc(UpsellServiceMessage2),
        buttonTextLine2: '',
        buttonIconPath: documentIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
    upsellFreeServicePremiumFeatures: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=867712&WT.mc_id=PROD_OL-Web_InApp_LeftNav_FreeServicesTreatmentUpgrade&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellDisplayedFreeServicePremiumFeatures',
        datapointNameClicked: 'LeftNavPremiumUpsellClickedFreeServicePremiumFeatures',
        buttonText: loc(UpsellServiceMessage3),
        buttonTextLine2: '',
        buttonIconPath: diamondIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
    upsellMailboxSecurityPremiumFeature: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=867712&WT.mc_id=PROD_OL-Web_InApp_LeftNav_AdvancedSecurityUpgrade&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellDisplayedMailboxSecurityPremiumFeatures',
        datapointNameClicked: 'LeftNavPremiumUpsellClickedMailboxSecurityPremiumFeatures',
        buttonText: loc(mailboxSecurityMessage),
        buttonTextLine2: '',
        buttonIconPath: diamondIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
    upsellGetMobileApp: {
        isHidden: false,
        url: 'https://go.microsoft.com/fwlink/?linkid=2101347&ep=',
        datapointNameShow: 'GetMobileUpsellDisplayed',
        datapointNameClicked: 'GetMobileUpsellClicked',
        buttonText: loc(GetMobileApplicationMessage),
        buttonTextLine2: '',
        buttonIconPath: ControlIcons.MobileSelected,
        buttonIconType: ButtonIconType.FabricIcon,
    },
    officeAppsNoUpsell: {
        isHidden: true,
        url: '',
        datapointNameShow: '',
        datapointNameClicked: '',
        buttonText: '',
        buttonTextLine2: '',
        buttonIconPath: '',
        buttonIconType: ButtonIconType.SvgIcon,
    },
    upsellWithOfficeApps: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=867712&WT.mc_id=PROD_OL-Web_InApp_LeftNav_WXPLeftNavT1&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellWXPTreatment2Displayed',
        datapointNameClicked: 'LeftNavPremiumUpsellWXPTreatment2Clicked',
        buttonText: loc(UpgradeMessage1),
        buttonTextLine2: loc(UpgradeMessage2),
        buttonIconPath: diamondIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
    upsellWithoutOfficeAppsControl: {
        isHidden: false,
        url:
            'https://go.microsoft.com/fwlink/?linkid=867712&WT.mc_id=PROD_OL-Web_InApp_LeftNav_WXPLeftNavControl&ep=',
        datapointNameShow: 'LeftNavPremiumUpsellWXPControlDisplayed',
        datapointNameClicked: 'LeftNavPremiumUpsellWXPControlClicked',
        buttonText: loc(UpgradeMessage1),
        buttonTextLine2: loc(UpgradeMessage2),
        buttonIconPath: diamondIconPath,
        buttonIconType: ButtonIconType.SvgIcon,
    },
};

export default upsellState;
